import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'

const Header = () => {
  const { t } = useTranslation('promotions')

  return (
    <div className="flx-str-ctr sticky z-10 bg-secondary px-5 py-2.5 left-0 top-[60px]">
      <Link to="/promotions" className="flx-str-ctr">
        <Icon
          className="fill-txt mr-[10px]"
          id="chevron-left"
          width="10"
          height="18"
        />
        <span className="text-base font-normal text-txt mr-5">
          {t('promotions-header')}
        </span>
      </Link>
    </div>
  )
}

export default Header
